import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product, ProductsResponse, DashboardStats } from '../../models/product.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/products`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getProducts(params?: { category?: string; subCategory?: string; brandGroup?: string; search?: string; sort?: string; page?: number; limit?: number }): Observable<ProductsResponse> {
    let httpParams = new HttpParams();
    if (params?.category) httpParams = httpParams.set('category', params.category);
    if (params?.subCategory) httpParams = httpParams.set('subCategory', params.subCategory);
    if (params?.brandGroup) httpParams = httpParams.set('brandGroup', params.brandGroup);
    if (params?.search) httpParams = httpParams.set('search', params.search);
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);
    if (params?.page) httpParams = httpParams.set('page', params.page.toString());
    if (params?.limit) httpParams = httpParams.set('limit', params.limit.toString());

    return this.http.get<ProductsResponse>(this.apiUrl, { params: httpParams });
  }

  getProductById(id: string): Observable<Product> {
    return this.http.get<Product>(`${this.apiUrl}/${id}`);
  }

  createProduct(productData: Partial<Product>): Observable<Product> {
    return this.http.post<Product>(this.apiUrl, productData);
  }

  updateProduct(id: string, productData: Partial<Product>): Observable<Product> {
    return this.http.put<Product>(`${this.apiUrl}/${id}`, productData);
  }

  deleteProduct(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }

  getDashboardStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(`${this.apiUrl}/stats/dashboard`);
  }

  triggerSeedDatabase(): Observable<{ message: string; admin: any; categoriesCount: number; productsCount: number }> {
    return this.http.post<any>(`${this.apiConfig.apiUrl}/seed`, {});
  }

  bulkCreateProducts(products: Partial<Product>[]): Observable<{ success: boolean | string; created: number; errorCount: number; errors: { row: number; title: string; reason: string }[] }> {
    return this.http.post<any>(`${this.apiUrl}/bulk`, { products });
  }
}



